import React, { useState } from 'react';
import { FileText } from 'lucide-react';
import ReportSelector from '../components/reports/ReportSelector';
import ARAgingReport from '../components/reports/ARAgingReport';
import WIPReport from '../components/reports/WIPReport';
import BillableHoursReport from '../components/reports/BillableHoursReport';
import CaseStatusReport from '../components/reports/CaseStatusReport';
import TrustBalanceReport from '../components/reports/TrustBalanceReport';
import UnbilledActivityReport from '../components/reports/UnbilledActivityReport';
import EffectiveRateReport from '../components/reports/EffectiveRateReport';
import CaseListReport from '../components/reports/CaseListReport';
import RevenueReport from '../components/reports/RevenueReport';
import TimeLogReport from '../components/reports/TimeLogReport';

const reportComponents = {
  'ar-aging': ARAgingReport,
  'wip': WIPReport,
  'billable-hours': BillableHoursReport,
  'case-status': CaseStatusReport,
  'trust-balances': TrustBalanceReport,
  'unbilled-activity': UnbilledActivityReport,
  'effective-rate': EffectiveRateReport,
  'case-list': CaseListReport,
  'revenue': RevenueReport,
  'time-log': TimeLogReport,
};

const Reports = () => {
  const [selectedReport, setSelectedReport] = useState('ar-aging');

  const ReportComponent = reportComponents[selectedReport];

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <FileText className="h-6 w-6 text-yellow-600" />
          Reports
        </h1>
        <p className="text-sm text-gray-500 mt-1">Financial, time tracking, and case management reports</p>
      </div>

      <div className="flex gap-6">
        <ReportSelector selectedReport={selectedReport} onSelect={setSelectedReport} />
        <div className="flex-1 min-w-0">
          {ReportComponent && <ReportComponent key={selectedReport} />}
        </div>
      </div>
    </div>
  );
};

export default Reports;
